/* eslint-disable no-undef */

import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import {withStyles} from '@material-ui/core/styles/index'

import {Grid, NativeSelect, InputLabel, FormHelperText, FormControl, Input, OutlinedInput, FilledInput, FormLabel} from '@material-ui/core'

const styles = theme => ({
    formControl: {
        width: '100%'
    },
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    label: {
        marginBottom: theme.spacing(1.25) + 'px!important'
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '4px!important'
        }
    },
    select: {
        '& fieldset': {
            border: theme.input && theme.input.border + '!important'
        }
    },
    outlinedSelect: {
        '& select': {
            backgroundColor: '#fff!important'
        }
    },
    kuukausiGrid: {
        margin: '0 -8px',
        maxWidth: 'calc(33.333333% + 16px)',
        flexBasis: 'calc(33.333333% + 16px)'
    },
    bigDescription: {
        '& p': {
            fontSize: '0.875rem',
            lineHeight: 1.43,
            color: theme.palette.text.primary,
            fontWeight: 600,
            marginTop: theme.spacing(1) + 'px!important',
            marginBottom: theme.spacing(-1)
        }
    }
})

class DateQuestion extends Component {
    state = {
        pvLabelWidth: 0,
        kkLabelWidth: 0,
        vuosiLabelWidth: 0,
        pv: '',
        kk: '',
        vuosi: ''
    }

    handleChange = (value, alias) => {
        this.setState({[alias]: value}, () => {
            const fullValue = this.state.vuosi + '-' + this.state.kk + '-' + this.state.pv
            this.props.onValueChanged(this.props.question.id, fullValue)
        })
    }

    componentDidMount() {
        this.setState({
            pvLabelWidth: ReactDOM.findDOMNode(this.pvInputLabelRef).offsetWidth,
            kkLabelWidth: ReactDOM.findDOMNode(this.kkInputLabelRef).offsetWidth,
            vuosiLabelWidth: ReactDOM.findDOMNode(this.vuosiInputLabelRef).offsetWidth
        })
    }

    getDayLabel() {
        if (process.env.MIX_APP_COUNTRY === 'denmark') {
            return 'Dag'
        }
        if (process.env.MIX_APP_COUNTRY === 'sweden') {
            return 'Dag'
        }
        return 'Päivä'
    }

    getMonthLabel() {
        if (process.env.MIX_APP_COUNTRY === 'denmark') {
            return 'Måned'
        }
        if (process.env.MIX_APP_COUNTRY === 'sweden') {
            return 'Månad'
        }
        return 'Kuukausi'
    }

    getYearLabel() {
        if (process.env.MIX_APP_COUNTRY === 'denmark') {
            return 'År'
        }
        if (process.env.MIX_APP_COUNTRY === 'sweden') {
            return 'År'
        }
        return 'Vuosi'
    }

    render() {
        const {classes, value, question, theme} = this.props
        const inputValue = value ? value : ''

        let days = []
        for (let i = 1; i <= 9; i++) {
            days.push('0' + i)
        }
        for (let i = 10; i <= 31; i++) {
            days.push(i)
        }
        let months = []
        for (let i = 1; i <= 9; i++) {
            months.push('0' + i)
        }
        for (let i = 10; i <= 12; i++) {
            months.push(i)
        }
        const currentYear = new Date().getFullYear()
        let years = []
        for (let i = currentYear - 15; i >= 1900; i--) {
            years.push(i)
        }
        const inputArr = inputValue.split('-')
        const pvValue = inputArr[2] ? inputArr[2] : ''
        const kkValue = inputArr[1] ? inputArr[1] : ''
        const vuosiValue = inputArr[0] ? inputArr[0] : ''

        return (
            <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)} className={classes.questionWrapper}>
                <FormLabel component="legend" className={classes.label + ' date-question-label'}>
                    {question.title}
                </FormLabel>
                <Grid container spacing={2}>
                    <Grid item xs={4} sm={4}>
                        <FormControl className={classes.formControl + ' inputText'} variant={theme.inputVariant}>
                            <InputLabel
                                className={'inputSelectLabel'}
                                ref={ref => {
                                    this.pvInputLabelRef = ref
                                }}
                            >
                                {this.getDayLabel()}
                            </InputLabel>
                            <NativeSelect
                                value={pvValue}
                                className={classes.select + ' ' + (theme.inputVariant === 'outlined' ? classes.outlinedSelect : null)}
                                onChange={event => this.handleChange(event.target.value, 'pv')}
                                input={
                                    theme.inputVariant === 'outlined' ? (
                                        <OutlinedInput
                                            variant={theme.inputVariant}
                                            error={question.valid === false}
                                            labelWidth={this.state.pvLabelWidth}
                                        />
                                    ) : theme.inputVariant === 'filled' ? (
                                        <FilledInput
                                            variant={theme.inputVariant}
                                            error={question.valid === false}
                                            labelWidth={this.state.pvLabelWidth}
                                        />
                                    ) : (
                                        <Input variant={theme.inputVariant} error={question.valid === false} labelWidth={this.state.pvLabelWidth}/>
                                    )
                                }
                            >
                                <option value=""/>
                                {days.map((value, key) => (
                                    <option value={value} key={key}>
                                        {key + 1}
                                    </option>
                                ))}
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sm={4} className={classes.kuukausiGrid}>
                        <FormControl className={classes.formControl + ' inputText'} variant={theme.inputVariant}>
                            <InputLabel
                                className={'inputSelectLabel'}
                                ref={ref => {
                                    this.kkInputLabelRef = ref
                                }}
                            >
                                {this.getMonthLabel()}
                            </InputLabel>
                            <NativeSelect
                                value={kkValue}
                                className={classes.select + ' ' + (theme.inputVariant === 'outlined' ? classes.outlinedSelect : null)}
                                onChange={event => this.handleChange(event.target.value, 'kk')}
                                input={
                                    theme.inputVariant === 'outlined' ? (
                                        <OutlinedInput
                                            variant={theme.inputVariant}
                                            error={question.valid === false}
                                            labelWidth={this.state.kkLabelWidth}
                                        />
                                    ) : theme.inputVariant === 'filled' ? (
                                        <FilledInput
                                            variant={theme.inputVariant}
                                            error={question.valid === false}
                                            labelWidth={this.state.kkLabelWidth}
                                        />
                                    ) : (
                                        <Input variant={theme.inputVariant} error={question.valid === false} labelWidth={this.state.kkLabelWidth}/>
                                    )
                                }
                            >
                                <option value=""/>
                                {months.map((value, key) => (
                                    <option value={value} key={key}>
                                        {key + 1}
                                    </option>
                                ))}
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sm={4} className={classes.questionGrid}>
                        <FormControl className={classes.formControl + ' inputText'} variant={theme.inputVariant}>
                            <InputLabel
                                className={'inputSelectLabel'}
                                ref={ref => {
                                    this.vuosiInputLabelRef = ref
                                }}
                            >
                                {this.getYearLabel()}
                            </InputLabel>
                            <NativeSelect
                                value={vuosiValue}
                                className={classes.select + ' ' + (theme.inputVariant === 'outlined' ? classes.outlinedSelect : null)}
                                onChange={event => this.handleChange(event.target.value, 'vuosi')}
                                input={
                                    theme.inputVariant === 'outlined' ? (
                                        <OutlinedInput
                                            variant={theme.inputVariant}
                                            error={question.valid === false}
                                            labelWidth={this.state.vuosiLabelWidth}
                                        />
                                    ) : theme.inputVariant === 'filled' ? (
                                        <FilledInput
                                            variant={theme.inputVariant}
                                            error={question.valid === false}
                                            labelWidth={this.state.vuosiLabelWidth}
                                        />
                                    ) : (
                                        <Input
                                            variant={theme.inputVariant}
                                            error={question.valid === false}
                                            labelWidth={this.state.vuosiLabelWidth}
                                        />
                                    )
                                }
                            >
                                <option value=""/>
                                {years.map((value, key) => (
                                    <option value={value} key={key}>
                                        {value}
                                    </option>
                                ))}
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    {question.valid === false && (
                        <Grid item xs={12} style={{paddingTop: 0}}>
                            <FormHelperText style={{marginTop: 0}} className={classes.errorText}>
                                {question.errorMessage}
                            </FormHelperText>
                        </Grid>
                    )}
                    {question.description && (
                        <Grid
                            item
                            xs={12}
                            style={{
                                paddingTop: 0
                            }}
                            className={process.env.MIX_APP_COUNTRY === 'denmark' ? classes.bigDescription : null}
                        >
                            <FormHelperText style={{marginTop: 0}}>{question.description}</FormHelperText>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(DateQuestion)
